import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "searchInput", "form"]

  setDateRange(event) {
    const days = parseInt(event.params.days, 10)
    const today = new Date()

    if (days === -1) {
      // Yesterday: start and end both set to yesterday
      const yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      const formatted = this.#formatDate(yesterday)
      this.startDateTarget.value = formatted
      this.endDateTarget.value = formatted
    } else {
      const start = new Date()
      if (days > 0) start.setDate(today.getDate() - days)
      this.startDateTarget.value = this.#formatDate(start)
      this.endDateTarget.value = this.#formatDate(today)
    }
  }

  resetFilters() {
    window.location.href = window.location.pathname
  }

  clearSearch() {
    this.searchInputTarget.value = ""
    this.formTarget.submit()
  }

  changePerPage(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("per_page", event.target.value)
    url.searchParams.delete("page")
    window.location.href = url.toString()
  }

  #formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
